export default __webpack_public_path__ + "static/media/sweater.2b0ae0bd.jpg";